import React from 'react'
import { Consumer } from 'components/CookieAcceptance/Context'

export default Component => props => (
  <Consumer>
    {consumerProps => <Component {...props} {...consumerProps} />}
  </Consumer>
)



// WEBPACK FOOTER //
// ./src/components/withCookieAcceptance.js